import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { SharedModule } from '@app/sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { ProductSelectionModule } from '@app/sharedModule/product-selection/product-selection.module';
import { MonacoEditorComponent } from './components/monaco-editor/monaco-editor.component';
import { SmartCartComponent } from './smart-cart.component';
import { SmartCartListComponent } from './smart-cart-list/smart-cart-list.component';
import { SmartCartFormComponent } from './smart-cart-form/smart-cart-form.component';
import { SmartCartFormOrderManagementComponent } from './smart-cart-form/components/smart-cart-form-order-management/smart-cart-form-order-management.component';
import { SmartCartFormGlobalSettingsComponent } from './smart-cart-form/components/smart-cart-form-global-settings/smart-cart-form-global-settings.component';
import { SmartCartFormDisplayConditionsComponent } from './smart-cart-form/components/smart-cart-form-display-conditions/smart-cart-form-display-conditions.component';
import { SmartCartFormEditorShellComponent } from './smart-cart-form/components/smart-cart-form-display-conditions/smart-cart-form-editor-shell.component';
import { SmartCartFormTokenSectionComponent } from './smart-cart-form/components/token-section/token-section.component';
import { SmartCartFormCustomTemplateConfirmDialogComponent } from './smart-cart-form/components/smart-cart-form-global-settings/custom-template-confirm-dialog.component';
import { SmartCartFormTopBarEditorComponent } from './smart-cart-form/widget-editors/top-bar/top-bar.component';
import { SmartCartFormAnnouncementBarEditorComponent } from './smart-cart-form/widget-editors/announcement-bar/announcement-bar.component';
import { SmartCartFormCartSubtotalEditorComponent } from './smart-cart-form/widget-editors/cart-subtotal/cart-subtotal.component';
import { SmartCartFormCheckoutAreaEditorComponent } from './smart-cart-form/widget-editors/checkout-area/checkout-area.component';
import { SmartCartFormDiscountCodesEditorComponent } from './smart-cart-form/widget-editors/discount-codes/discount-codes.component';
import { SmartCartFormCartItemsEditorComponent } from './smart-cart-form/widget-editors/cart-items/cart-items.component';
import { SmartCartFormDigitalUpsellEditorComponent } from './smart-cart-form/widget-editors/digital-upsell/digital-upsell.component';
import { SmartCartFormOrderProtectionEditorComponent } from './smart-cart-form/widget-editors/order-protection/order-protection.component';
import { StandaloneWidgetsListComponent } from './standalone-widgets/standalone-widgets-list/standalone-widgets-list.component';
import { StandaloneWidgetFormComponent } from './standalone-widgets/standalone-widget-form/standalone-widget-form.component';
import { OrderProtectionPreviewComponent } from './standalone-widgets/order-protection-preview/order-protection-preview.component';
import { SmartCartFormUpsellItemsEditorComponent } from './smart-cart-form/widget-editors/upsell-items/upsell-items.component';
import { SmartCartUpsellProductSelectionComponent } from './smart-cart-form/widget-editors/upsell-items/product-selection/product-selection.component';
import { SmartCartUpsellRuleGroupComponent } from './smart-cart-form/widget-editors/upsell-items/product-selection/product-rule-group/product-rule-group.component';
import { SmartCartUpsellAppearanceComponent } from './smart-cart-form/widget-editors/upsell-items/product-selection/product-appearance/product-appearance.component';
import { SmartCartFormCustomCodeComponent } from './smart-cart-form/widget-editors/custom-code/custom-code.component';
import { SmartCartFormCustomCodeDialogComponent } from './smart-cart-form/widget-editors/custom-code/custom-code-dialog.component';
import { SmartCartPreviewDrawerComponent } from './smart-cart-form/preview/smart-cart-preview-drawer/smart-cart-preview-drawer.component';
import { TopBarPreviewComponent } from './smart-cart-form/preview/widget-previews/top-bar-preview/top-bar-preview.component';
import { CartItemsPreviewComponent } from './smart-cart-form/preview/widget-previews/cart-items-preview/cart-items-preview.component';
import { CartSubtotalPreviewComponent } from './smart-cart-form/preview/widget-previews/cart-subtotal-preview/cart-subtotal-preview.component';
import { CheckoutAreaPreviewComponent } from './smart-cart-form/preview/widget-previews/checkout-area-preview/checkout-area-preview.component';
import { DiscountCodesPreviewComponent } from './smart-cart-form/preview/widget-previews/discount-codes-preview/discount-codes-preview.component';
import { AnnouncementBarPreviewComponent } from './smart-cart-form/preview/widget-previews/announcement-bar-preview/announcement-bar-preview.component';
import { SmartCartFormGoalsProgressBarEditorComponent } from './smart-cart-form/widget-editors/goals-progress-bar/goals-progress-bar.component';
import { SmartCartGoalsCustomCodeCardComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/custom-code-card/custom-code-card.component';
import { SmartCartGoalsSettingsTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/settings-tab/settings-tab.component';
import { SmartCartGoalsGoalCardComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/goal-card/goal-card.component';
import { SmartCartGoalThresholdTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/goal-card/goal-threshold-tab/goal-threshold-tab.component';
import { SmartCartGoalOfferTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/goal-card/goal-offer-tab/goal-offer-tab.component';
import { SmartCartGoalAppearanceTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/goal-card/goal-appearance-tab/goal-appearance-tab.component';
import { SmartCartGoalsTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/goals-tab/goals-tab.component';
import { SmartCartGoalsTimerTabComponent } from './smart-cart-form/widget-editors/goals-progress-bar/components/timer-tab/timer-tab.component';
import { SmartCartTimerConfigComponent } from './smart-cart-form/components/timer-config/timer-config.component';
import { GoalsProgressBarPreviewComponent } from './smart-cart-form/preview/widget-previews/goals-progress-bar-preview/goals-progress-bar-preview.component';
import { UpsellItemsPreviewComponent } from './smart-cart-form/preview/widget-previews/upsell-items-preview/upsell-items-preview.component';
import { DigitalUpsellPreviewComponent } from './smart-cart-form/preview/widget-previews/digital-upsell-preview/digital-upsell-preview.component';

@NgModule({
  declarations: [
    MonacoEditorComponent,
    SmartCartComponent,
    SmartCartListComponent,
    SmartCartFormComponent,
    SmartCartFormOrderManagementComponent,
    SmartCartFormGlobalSettingsComponent,
    SmartCartFormDisplayConditionsComponent,
    SmartCartFormEditorShellComponent,
    SmartCartFormTokenSectionComponent,
    SmartCartFormCustomTemplateConfirmDialogComponent,
    SmartCartFormTopBarEditorComponent,
    SmartCartFormAnnouncementBarEditorComponent,
    SmartCartFormGoalsProgressBarEditorComponent,
    SmartCartGoalsCustomCodeCardComponent,
    SmartCartGoalsSettingsTabComponent,
    SmartCartGoalsGoalCardComponent,
    SmartCartGoalThresholdTabComponent,
    SmartCartGoalOfferTabComponent,
    SmartCartGoalAppearanceTabComponent,
    SmartCartGoalsTabComponent,
    SmartCartGoalsTimerTabComponent,
    SmartCartTimerConfigComponent,
    SmartCartFormCartSubtotalEditorComponent,
    SmartCartFormCheckoutAreaEditorComponent,
    SmartCartFormDiscountCodesEditorComponent,
    SmartCartFormCartItemsEditorComponent,
    SmartCartFormDigitalUpsellEditorComponent,
    SmartCartFormOrderProtectionEditorComponent,
    StandaloneWidgetsListComponent,
    StandaloneWidgetFormComponent,
    OrderProtectionPreviewComponent,
    SmartCartFormUpsellItemsEditorComponent,
    SmartCartUpsellProductSelectionComponent,
    SmartCartUpsellRuleGroupComponent,
    SmartCartUpsellAppearanceComponent,
    SmartCartFormCustomCodeComponent,
    SmartCartFormCustomCodeDialogComponent,
    SmartCartPreviewDrawerComponent,
    TopBarPreviewComponent,
    CartItemsPreviewComponent,
    CartSubtotalPreviewComponent,
    CheckoutAreaPreviewComponent,
    DiscountCodesPreviewComponent,
    AnnouncementBarPreviewComponent,
    GoalsProgressBarPreviewComponent,
    UpsellItemsPreviewComponent,
    DigitalUpsellPreviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StorybookModule,
    MatDialogModule,
    ProductSelectionModule,
    MonacoEditorModule.forRoot({ baseUrl: '/assets/monaco/vs' }),
  ],
  exports: [SmartCartComponent],
})
export class SmartCartModule {}
